import styled from 'styled-components/macro';
import {CSS_MOBILE_BREAKPOINT,CSS_PADDING,CSS_COLOR_BORDERS,CSS_SELECTOR_RADIUS} from '../constants';

import download from '../assets/big_download.svg';
import rotateright from '../assets/big_rotateright.svg';
import rotateleft from '../assets/big_rotateleft.svg';
import fullscreen from '../assets/big_fullscreen.svg';
import partscreen from '../assets/big_partscreen.svg';

const BUTTONS_WIDTH = 44;
const LINE_HEIGHT = 20;

const ButtonsStyled = styled.div`
	.flexpart {
		display: flex;
	}
	.bottom,.top,.left,.right{
		position: absolute;
	}
	.bottom{
		bottom: ${CSS_PADDING};
	}
	.right{
		right: ${CSS_PADDING};
	}
	.left{
		left: ${CSS_PADDING};
	}
	.top{
		top: ${CSS_PADDING};
	}
	.button {
		width: ${BUTTONS_WIDTH}px;
		line-height: ${LINE_HEIGHT}px;
		padding-top: ${(BUTTONS_WIDTH-LINE_HEIGHT)/2}px;
		padding-bottom: ${(BUTTONS_WIDTH-LINE_HEIGHT)/2}px;
		min-height: ${BUTTONS_WIDTH}px;
		&.with-text {
			width: auto;
			padding-left: ${BUTTONS_WIDTH}px;
			padding-right: ${BUTTONS_WIDTH/4}px;
		}

		background: rgba(255, 255, 255, 0.8);
		border-radius: ${CSS_SELECTOR_RADIUS};
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
		backdrop-filter: blur(3px);
		-webkit-backdrop-filter: blur(3px);
		border: 1px solid ${CSS_COLOR_BORDERS};

		background-repeat: no-repeat;
		background-position: 5px 50%;

		&.download {
			background-image: url(${download});
			color: #fff;

			background-color: #0093ef;
			border: 1px solid rgba(0, 0, 0, 0.2);
			padding-top: 5px;
			padding-bottom: 5px;

			&:hover {
				background-color: #0084d6;
				&:active {
					background-color: #0084d6;
				}
			}

		}
		&.rotateright {
			background-image: url(${rotateright});
		}
		&.rotateleft {
			background-image: url(${rotateleft});
		}
		&.fullscreen {
			background-image: url(${fullscreen});
		}
		&.partscreen {
			background-image: url(${partscreen});
		}
		&.fullscreen,&.partscreen {
			margin-left: auto !important;
		}

		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		&:hover {
			background-color: rgba(245,245,245,0.8);
			border-color:#bbb;
			&:active {
				background-color: rgba(225,225,225,0.8);
				border-color:#777;
			}
		}
	}
	.button+.button {
		margin-left: ${CSS_PADDING};
	}
	@media ${CSS_MOBILE_BREAKPOINT}{
		.button.with-text {
			width: ${BUTTONS_WIDTH}px;
			padding-left: 0;
			padding-right: 0;
			span {
				display: none;
			}
		}
	}
`;


function ControlButtons({
	onDownload,
	onRotateright,
	onRotateleft,
	toggleFullscreen,
	is_fullscreen = false
}){
	// Downloads may crash on iOS 16 (iPhone 8)
	// even with only 1 image
	// even on low resolution
	const show_rotate = false;
	const disable_downloads = false&&/iPad|iPhone|iPod/.test(navigator.userAgent);
	return (
		<ButtonsStyled>
			<div className="flexpart bottom left">
				{!disable_downloads&&!is_fullscreen&&<div onClick={onDownload} className="button download with-text"><span>Téléchargez les images <br />permis de construire</span></div>}
				{show_rotate&&<div onClick={onRotateright} className="button rotateright" />}
				{show_rotate&&<div onClick={onRotateleft} className="button rotateleft" />}
			</div>
			{toggleFullscreen&&(!is_fullscreen)&&<div onClick={toggleFullscreen} className="button fullscreen with-text bottom right"><span>Agrandir</span></div>}
			{toggleFullscreen&&is_fullscreen&&<div onClick={toggleFullscreen} className="button partscreen with-text bottom right"><span>Quitter le plein écran</span></div>}
		</ButtonsStyled>
	);
}

export default ControlButtons;
